import styled from '../../../../theme'
import { IWithSize } from '../../../../containers/BookingCalendar/Calendar/Calendar'

const Label = styled.div<IWithSize & { active: boolean }>`
  font-family: Montserrat;
  font-size: ${({ size }) => (size ? 15 * size : 15)}px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color ${props =>
    props.active
      ? props.theme.colors.palette.emerald
      : props.theme.colors.palette.slateGrey};
  white-space: nowrap;
`
export default Label
